import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CheckupForm from "../../components/schedaCliente/checkup";
import Page from "../../components/general/page";
import { FormattedMessage } from "react-intl";
import {
  getKpiList,
  getKpiTitles
} from "../../store/actions/analytics/index";
import { useIntl } from "react-intl";

const CheckupView = props => {
  const {  pageRef } = props;
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);

  const intl = useIntl();

  const dispatch = useDispatch();

  const selectedCompanyName = company?.companies?.find(el => el.id === main.clientIdSelected);
  const myType = main.myType;

  useEffect(() => {
    dispatch(getKpiList());
    dispatch(getKpiTitles());
  }
  , []);

  return (
    <Page
      pageRef={pageRef}
      title={"CHECKUP D'IMPRESA"}
      subtitle={
        selectedCompanyName?.ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + main.companySelected
      }
      backText={myType === "STUDIO" ? <FormattedMessage id="deadlines.goClientList" /> : <FormattedMessage id="deadlines.goBack"/> }      
      backUrl={myType === "STUDIO" ? "/scheda-cliente" : "/"}
      className='contentStructure transparent'
    >
      <CheckupForm />
    </Page>
  );
};

export default CheckupView;